export const checkBrandsForPricingEstimate = (brand: string): boolean => {
  const eligibleBrands = ["LAP"];
  return eligibleBrands.includes(brand) ?? null;
};
